import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Newsletter from "@/components/feature/Newsletter";
import SEOSchema from "@/components/feature/SEOSchema";
import { siteConfig, aboutData, testimonials } from "@/mocks/comics";

export default function About() {
  return (
    <>
      <SEOSchema
        type="WebPage"
        pageUrl="/about"
        pageTitle={`关于我们 - ${siteConfig.name}`}
        pageDescription={`了解${siteConfig.name}的品牌故事、发展历程与联系方式。我们致力于为中文读者提供最优质的韩国漫画阅读体验。`}
        breadcrumbs={[
          { name: "首页", url: "/" },
          { name: "关于我们", url: "/about" },
        ]}
        contactInfo={{
          email: siteConfig.email,
          wechat: siteConfig.social.wechat,
        }}
      />

      <Navbar />

      <main>
        <section className="w-full px-4 md:px-6 pt-24 pb-14 md:pt-32 md:pb-20 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="rounded-2xl overflow-hidden mb-12 md:mb-16">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20artistic%20illustration%20of%20a%20cozy%20creative%20studio%20workspace%20with%20large%20monitors%20displaying%20colorful%20digital%20art%2C%20comics%20and%20illustration%20books%20on%20wooden%20shelves%2C%20warm%20ambient%20lighting%20from%20desk%20lamps%2C%20modern%20minimalist%20interior%2C%20creative%20atmosphere%2C%20soft%20color%20palette%20with%20coral%20and%20cream%20accents%2C%20clean%20editorial%20photography%20style&width=1600&height=600&seq=about-hero&orientation=landscape"
                alt="韩漫屋品牌故事"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="text-center max-w-3xl mx-auto mb-14 md:mb-20">
              <h1 className="text-3xl md:text-5xl font-black font-heading text-foreground-950 leading-tight">
                关于<span className="text-primary-500">韩漫屋</span>
              </h1>
              <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed">
                {aboutData.brandStory}
              </p>
              <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed">
                {aboutData.mission}
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 md:gap-8 mb-14 md:mb-20">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="text-3xl md:text-5xl font-black font-heading text-primary-500">
                    {stat.value}
                  </p>
                  <p className="mt-2 text-xs md:text-sm text-foreground-400">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
              <div className="flex-1">
                <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300/60 text-xs font-semibold text-accent-600 bg-accent-50/50 whitespace-nowrap">
                  品牌认证
                </span>
                <h2 className="mt-4 text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
                  值得信赖的漫画平台
                </h2>
                <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                  韩漫屋始终坚持内容品质第一的原则，与多家韩国顶级漫画平台建立了深度合作关系。
                  我们的编辑团队由资深漫画爱好者和行业专家组成，确保每一部推荐作品都经过严格筛选。
                </p>
                <div className="grid grid-cols-2 gap-6 mt-8">
                  <div>
                    <p className="text-3xl md:text-4xl font-black font-heading text-foreground-950">
                      500+
                    </p>
                    <p className="mt-1 text-xs text-foreground-400">收录韩漫作品</p>
                  </div>
                  <div>
                    <p className="text-3xl md:text-4xl font-black font-heading text-foreground-950">
                      4
                    </p>
                    <p className="mt-1 text-xs text-foreground-400">韩国合作平台</p>
                  </div>
                </div>
              </div>

              <div className="flex-1 w-full">
                <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20bright%20office%20space%20with%20people%20collaborating%20around%20a%20large%20table%2C%20colorful%20sticky%20notes%20on%20glass%20wall%2C%20creative%20studio%20atmosphere%2C%20warm%20natural%20light%20from%20large%20windows%2C%20casual%20professional%20environment%2C%20editorial%20photography%20style%20with%20soft%20coral%20and%20warm%20neutral%20tones&width=800&height=600&seq=about-partners&orientation=landscape"
                    alt="韩漫屋团队"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold bg-background-50/90 text-foreground-950 whitespace-nowrap">
                      我们的团队
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300/60 text-xs font-semibold text-secondary-600 bg-secondary-50/50 whitespace-nowrap">
                合作伙伴
              </span>
              <h2 className="mt-4 text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
                行业声誉
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
                与我们紧密合作的韩国顶级漫画平台
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
              {aboutData.partners.map((partner) => (
                <div
                  key={partner.name}
                  className="p-6 rounded-lg bg-background-100 border border-background-200 text-center hover:border-accent-200 transition-all duration-300"
                >
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100">
                    <i className="ri-building-2-line text-lg text-accent-600" />
                  </div>
                  <h3 className="mt-3 text-sm font-bold font-heading text-foreground-950">
                    {partner.name}
                  </h3>
                  <p className="mt-1 text-xs text-foreground-400">{partner.role}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <div className="flex items-center justify-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary-500" />
                <span className="text-xs font-semibold text-primary-600 whitespace-nowrap">
                  读者口碑
                </span>
              </div>
              <h2 className="mt-3 text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
                听听他们怎么说
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-500">
                来自合作伙伴和读者的真实评价
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {testimonials.slice(0, 6).map((item, idx) => (
                <div
                  key={item.id}
                  className={`p-5 md:p-6 rounded-lg bg-background-50 border border-background-200 ${
                    idx === 5 ? "opacity-70" : ""
                  }`}
                >
                  <div className="flex items-center gap-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${
                          i < item.rating
                            ? "ri-star-fill text-secondary-500"
                            : "ri-star-line text-foreground-300"
                        }`}
                      />
                    ))}
                  </div>
                  <h3 className="mt-3 text-sm font-bold font-heading text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {item.content}
                  </p>
                  <div className="mt-4 flex items-center gap-3">
                    <img
                      src={item.avatar}
                      alt={item.name}
                      className="w-9 h-9 rounded-full object-cover"
                      loading="lazy"
                    />
                    <div>
                      <p className="text-xs font-semibold text-foreground-950">
                        {item.name}
                      </p>
                      <p className="text-[11px] text-foreground-400">{item.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 leading-tight">
              与我们取得联系
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500">
              合作洽谈、内容反馈、广告投放等请通过以下方式联系我们
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mt-10">
              <div className="p-6 rounded-lg bg-background-100 border border-background-200">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-mail-line text-xl text-primary-500" />
                </div>
                <h3 className="mt-4 text-sm font-bold font-heading text-foreground-950">
                  电子邮箱
                </h3>
                <a
                  href={`mailto:${siteConfig.email}`}
                  className="mt-2 text-xs text-primary-500 hover:text-primary-600 transition-colors cursor-pointer block"
                >
                  {siteConfig.email}
                </a>
              </div>

              <div className="p-6 rounded-lg bg-background-100 border border-background-200">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-wechat-line text-xl text-accent-600" />
                </div>
                <h3 className="mt-4 text-sm font-bold font-heading text-foreground-950">
                  微信公众号
                </h3>
                <span className="mt-2 text-xs text-foreground-500 block">
                  {siteConfig.social.wechat}
                </span>
              </div>

              <div className="p-6 rounded-lg bg-background-100 border border-background-200">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-notification-3-line text-xl text-secondary-600" />
                </div>
                <h3 className="mt-4 text-sm font-bold font-heading text-foreground-950">
                  站内动态
                </h3>
                <a
                  href={siteConfig.social.updates}
                  rel="nofollow"
                  className="mt-2 text-xs text-primary-500 hover:text-primary-600 transition-colors cursor-pointer block"
                >
                  最新更新
                </a>
              </div>
            </div>
          </div>
        </section>

        <Newsletter />
      </main>

      <Footer />
    </>
  );
}
